import React from 'react';

// Panel whose title toggles its body; actions and a subtitle sit in the header row.
function CollapsiblePanel({ title, sub, collapsed, onToggle, actions, children }) {
  return (
    <section className="panel">
      <div className="panel-head">
        <h2>
          <button className="panel-toggle" onClick={onToggle} aria-expanded={!collapsed}>
            <span className="panel-caret" aria-hidden="true">{collapsed ? '▸' : '▾'}</span>
            {title}
          </button>
        </h2>
        {sub && <span className="panel-sub">{sub}</span>}
        {actions && !collapsed && <div className="panel-actions">{actions}</div>}
      </div>
      {!collapsed && children}
    </section>
  );
}

export default CollapsiblePanel;
